function _(n,i,t){function e(n){return n}t.init=function(){},t.forward=e,t.inverse=e,t.names=["longlat","identity"]}
//# sourceMappingURL=longlat.min.js.map